module.exports = __webpack_public_path__ + "static/media/small_platform.f411731e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameSpacePort/small_platform.png
// module id = 2483
// module chunks = 0